import React from "react";
import Page from "../../../layout/web/Page";
import Title from "../../../components/Common/Title";
import Connector from "../../../redux/connector";
import PluginAddDeleteList from "../../../components/Common/PluginAddDeleteList2";
import {fetchDataEntity} from "../../../api/entity-data";
import {

    getCompanyList,
    getYesNoOption,
    loadData
} from "./lib";


class QuoteServicePlannedSitePage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Data: [],
            Companies: [],
            Modules: [],
            Clients: [],
            Projects:[],
            Items:[],
            Sites:[],
            isLoading: false,
            company: "",
            component: "list",
            newEntry: {},
        }
    }

    componentDidMount = async () => {
        await fetchDataEntity("Companies", "client/entity", "company", this)
        await this.loadInitialData()
    }

    loadInitialData = async () => {
        await loadData("modules", "Projects",this);
        await loadData("SettingInvoiceServiceDebtors", "Clients",this);
    }

    getProjectList = (data,org) => {
        let ls = [];
        for (let i in data) {
            let row = data[i];
            if (row.org === org) {
                ls.push({
                    key: row.name,
                    val: row.name
                });
            }
        }
        return ls;
    }
    getClientOption=()=>{
        let ls = [];
        for (let i in this.state.Clients) {
            let row = this.state.Clients[i];
            if (row.org === this.state.newEntry.selectedCompany) {
                ls.push({
                    key: row.name,
                    val: row.name
                });
            }
        }
        return ls;
    }
    render() {
        const org = this.state.newEntry.selectedCompany;
        const companyOptions = getCompanyList(this.state.Companies);
        const projectOptions =this.getProjectList(this.state.Projects,org);
        const clientOptions = this.getClientOption();

        console.log("KKKKDisplay Selected Project: ",this.state.newEntry.selectedCompany," > ",this.state);

        return (
            <Page {...this.props}>
                <div style={{
                    minHeight: "100%",
                    maxHeight: "100%",
                }}>
                    <Title style={styles.title}>Setup Service Site Listing</Title>
                    <div style={{minWidth: "100%", padding: 10}}>
                        <PluginAddDeleteList
                            _this={this}
                            targetEntity={"QuoteServicePlannedSite"}
                            depending={{
                                "org": {
                                    targetKey: "CustomerNumber",
                                    displayKey: "Name",
                                    storageTable: "Companies"
                                },
                                /*"client":{
                                    targetKey: "name",
                                    displayKey: "name",
                                    storageTable: "Clients"
                                }*/
                            }}
                            fields={[
                                {
                                    name: "org",
                                    dataType: "option",
                                    required: true,
                                    label: "Company",
                                    options: companyOptions,
                                    depending: {stateKey: "org", displayKey: "Name", storageTable: "Companies"}
                                },
                                {
                                    name: "client",
                                    dataType: "option",
                                    required: true,
                                    label: "Debtor",
                                    options: clientOptions,
                                    depending: {stateKey: "org", displayKey: "Name", storageTable: "Companies"}
                                },
                                {
                                    name: "site",
                                    dataType: "text",
                                    required: true,
                                    label: "Site",
                                },


                                {
                                    name: "units",
                                    dataType: "float",
                                    required: true,
                                    label: "Units",
                                },
                                {
                                    name: "rate",
                                    dataType: "float",
                                    required: true,
                                    label: "Rate",
                                },




                                {
                                    name: "mon",
                                    dataType: "boolean",
                                    required: true,
                                    label: "Monday",
                                    options: getYesNoOption()
                                },
                                {
                                    name: "tue",
                                    dataType: "boolean",
                                    required: true,
                                    label: "Tuesday",
                                    options: getYesNoOption()
                                },
                                {
                                    name: "wed",
                                    dataType: "boolean",
                                    required: true,
                                    label: "Wednesday",
                                    options: getYesNoOption()
                                },
                                {
                                    name: "thu",
                                    dataType: "boolean",
                                    required: true,
                                    label: "Thursday",
                                    options: getYesNoOption()
                                },
                                {
                                    name: "fri",
                                    dataType: "boolean",
                                    required: true,
                                    label: "Friday",
                                    options: getYesNoOption()
                                },
                                {
                                    name: "sat",
                                    dataType: "boolean",
                                    required: true,
                                    label: "Saturday",
                                    options: getYesNoOption()
                                },
                                {
                                    name: "sun",
                                    dataType: "boolean",
                                    required: true,
                                    label: "Sunday",
                                    options: getYesNoOption()
                                },


                            ]}
                            deleteKeys={[
                                {key: "org", type: "string"},
                                {key: "client", type: "string"},
                                {key: "site", type: "string"},
                            ]}
                            stateArray={"Data"}
                            table={"QuoteServicePlannedSite"}
                            addFormText={"Quote Service Site Listing"}
                            stepTitle={"Setup Quote Service Site Listing"}

                            filterByCompany={true}
                            displayRules={[
                                {rowKey:"org",stateKey:"selectedCompany"},
                                {rowKey:"client",stateKey:"selectedClient"},

                            ]}
                            extraFilters={[
                                {
                                    recordKey:"key",
                                    recordValue:"val",
                                    stateKey:"client",
                                    filterRecordKey:"client",
                                    filterStateKey:"selectedClient",
                                    allowBlank:true,
                                    name:"selectedClient",
                                    label:"Debtor",
                                    options: clientOptions,
                                    errorMsg: "Sorry you can't save, Please select your client!"
                                },
                            ]}

                            sortMe={"name"}

                        />

                    </div>
                </div>
            </Page>
        )
    }
}


export default Connector(QuoteServicePlannedSitePage);

const styles = {
    container: {},
    title: {
        minWidth: "100%",
        borderBottomWidth: 1,
        borderColor: "gray"
    }
}

